module.exports = "img/fullscreen.dbcb0c8.svg";